'use strict';

// Keep this in sync with AccountExternalService.class.php

module.exports = {
    SERVICE_TYPE_CODE_BOXNET: 'B',
    SERVICE_TYPE_CODE_DROPBOX: 'D',
    SERVICE_TYPE_CODE_GOOGLE_DRIVE: 'G',
    SERVICE_TYPE_CODE_GOOGLE_APPS: 'A',
    SERVICE_TYPE_CODE_GOOGLE_DOCS: 'F',
    SERVICE_TYPE_CODE_EVERNOTE: 'E',
    SERVICE_TYPE_CODE_MS_SP: 'S',
    SERVICE_TYPE_CODE_MS_OFFICE: 'O',
    SERVICE_TYPE_CODE_MS_OUTLOOK: 'L',
    SERVICE_TYPE_CODE_SKYDRIVE: 'K', // OneDrive
    SERVICE_TYPE_CODE_QQ_CATALYST: 'Q',
    SERVICE_TYPE_CODE_HUBSPOT: 'H',
    SERVICE_TYPE_CODE_SLACK: 'C',
    SERVICE_TYPE_ORACLECLOUD: 'R',
    SERVICE_TYPE_ALL: 'ALL' // used when calling syncFileWrapper.php worker
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/constants/ExternalServiceTypes.js
 ** module id = 631
 ** module chunks = 0
 **/